import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import English from "./LanguageList/english.json";
import Gujarati from "./LanguageList/gujarati.json";
import Hindi from "./LanguageList/hindi.json";
import French from "./LanguageList/french.json";
import { getCookie } from "utils/cookie";

const supportedLanguages = ["en", "gu", "hi", "fr"];
const browserLang = (navigator.language || "en").split("-")[0];

const defaultLanguage = supportedLanguages.includes(browserLang)
  ? browserLang
  : "en";

let savedLang = getCookie("webLanguage") || defaultLanguage;

savedLang = savedLang.split("-")[0];

if (!supportedLanguages.includes(savedLang)) {
  savedLang = "en";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: English },
    gu: { translation: Gujarati },
    hi: { translation: Hindi },
    fr: { translation: French },
  },
  lng: savedLang,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  returnObjects: true,
});

export default i18n;
